import {Timer, Tween} from '@gongxigames/framework/core';

export type UpdateFunction = (dt: number) => void;

export interface IUpdateManager {
    add(updatable: IUpdatable): void;

    remove(updatable: IUpdatable): void;

    addUpdateFunction(updateFunction: UpdateFunction): void;

    removeUpdateFunction(updateFunction: UpdateFunction): void;

    removeAll(): void;

    removeUpdatebleObjects(): void;

    removeUpdatebleFunctions(): void;

    addTimer(callback: Function, duration: number, start?: boolean): Timer;

    addTween(object: any): Tween;
}

export interface IUpdatable {
    updateManager?: IUpdateManager;

    isPlaying: boolean;

    start(): void;

    stop(): void;

    pause(): void;

    update(dt: number): void;
}
